import AUTH_API from '@services/auth.service';
import convertToFormData from '@utils/helpers/convertToFormData';
import {
  IAssignStarterWorksheetFormData,
  IAssignStarterWorksheetRes,
  ICreateRevisionWorksheetFormData,
  ICreateRevisionWorksheetRes,
  IGenerateRevisionWorksheetReq,
  IGenerateRevisionWsRes,
} from '@models/interfaces/worksheet.interface';

interface WorksheetFormData {
  topic_ids?: string | string[];
  subject_id?: number;
}

const WorksheetServices = {
  async createRevisionWorksheet(formData: ICreateRevisionWorksheetFormData) {
    return await AUTH_API.post<ICreateRevisionWorksheetRes>(
      'student/generate_revision_ws/json',
      convertToFormData(formData),
    );
  },
  async assignStarterWorksheet(formData: IAssignStarterWorksheetFormData) {
    return await AUTH_API.post<IAssignStarterWorksheetRes>(
      '/parents/assign_worksheet/json',
      convertToFormData(formData),
    );
  },
  async generateRevisionWs(formData: IGenerateRevisionWorksheetReq) {
    return await AUTH_API.post<IGenerateRevisionWsRes>(
      `/student/generate_revision_ws/json`,
      convertToFormData(formData),
    );
  },
  async getAbusedWorksheetData(formData: WorksheetFormData) {
    return await AUTH_API.post(
      'student/get_abused_worksheet_data/json',
      convertToFormData(formData),
    );
  },
};
export default WorksheetServices;
